import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import { MdDeleteForever, MdKeyboardArrowDown } from "react-icons/md";
import { BiChevronDown,BiSearchAlt2, BiSearchAlt } from "react-icons/bi";
import getitemaction from "../../context/action/buy/getitemaction";
import numberbeautify from "../../utils/numberbeautify";
import createaction from "../../context/action/sell/createaction";
import Sellinvoicedetailmodal from "./sellinvoicedetailmodal";
import getinvoiceaction from "../../context/action/sell/getinvoiceaction";
import '../../component/css/onprintcss.css';
import Sellitemprint from "./sellitemprint";
import money_rounding from "../../utils/money_rounding";
import iqd_rounding from "../../utils/iqd_rounding";
import moment from "moment/moment";

const Sell = () => {
  const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);
  const [items, setitems] = useState([]);
  const [text, settext] = useState();
  const [note, setnote] = useState();
  const [show, setshow] = useState(false);
  const [invoice_detail, setinvoice_detail] = useState();
  const [from, setfrom] = useState();
  const [invoiceno, setinvoiceno] = useState(0);
  const [invoicetype, setinvoicetype] = useState('cash');
  const [customer_id, setcustomer_id] = useState(1);
  const [customer_toggle, setcustomer_toggle] = useState(false);
  const [service_toggle, setservice_toggle] = useState(false);
  const [customer_search, setcustomer_search] = useState('');
  const [service_search, setservice_search] = useState('');
  
  const [sell_loading, setsell_loading] = useState(false);
  const [stopsell, setstopsell] = useState(false);
  const [error, seterror] = useState(false);

  const printit=(invoiceno)=>{
    setinvoiceno(invoiceno);
    setTimeout(() => {
      window.print();
    }, 500);
  }
  return (
    <div>
      <Sellitemprint username={initState.token.username} items={invoice_detail?invoice_detail.items:items} invoiceno={invoiceno} />
      
      <div className="print_hide">
        <Sellinvoicedetailmodal
          show={show}
          setshow={setshow}
          invoice_detail={invoice_detail}
          setinvoice_detail={setinvoice_detail}
          printit={printit}
        />

        {/* Main content */}
      <div className="min-h-screen bg-slate-50 p-6 md:p-8">
        {/* Page Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-2xl font-bold text-slate-800">فرۆشتن</h1>
            <p className="text-sm text-slate-400 mt-0.5">-</p>
          </div>
        </div>

        {/* Search and action section */}
        <div className="bg-gray-400 border border-gray-500 rounded-xl p-6 mb-6 shadow-sm">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 items-end">
            {/* <div className="col-span-4 lg:col-span-3 relative"> */}
              {/* Item/Barcode Input */}
              <div className="w-full">
                <label className="block text-base font-medium text-white mb-1 text-right">
                  ناوی ئایتم / باڕکۆد
                </label>
                <input
                  className="w-full h-12 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                  type="text"
                  value={text}
                  onClick={(val)=>val.target.select()}
                  onChange={(val) => settext(val.target.value)}
                  autoFocus
                  onKeyDown={(key) => {
                    if (key.key === "Enter") {
                      getitemaction(text)(recaller)(setrecaller)(items)(setitems)(settext);
                    }
                  }}
                />
              </div>

              {/* Invoice Type Select */}
              <div className="w-full">
                <label className={"block text-base font-medium text-white mb-1 text-right"}>
                  جۆری پسوڵە
                </label>
                <select
                  disabled={customer_id==1}
                  className={
                    customer_id==1
                    ? "w-full h-12 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-gray-200 cursor-not-allowed"
                    : "w-full h-12 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                  }
                  value={invoicetype}
                  onChange={(val) => setinvoicetype(val.target.value)}
                >
                  <option value="cash">کاش</option>
                  <option value="loan">قەرز</option>
                </select>
              </div>

              {/* Customer Dropdown */}
              <div className="w-full relative">
                <label className={"block text-base font-medium text-white mb-1 text-right"}>
                  کڕیار
                </label>
                <div className="w-full h-12 pr-2 pl-0 border flex justify-between items-center border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white" onClick={()=>{setcustomer_toggle(!customer_toggle)}}>
                  {initState.customer.filter((lis)=>lis.customer_id==customer_id)[0]?.customer_name}
                  <MdKeyboardArrowDown size={18} className={`text-gray-900 transition-transform duration-200 ${customer_toggle ? 'rotate-180' : ''}`} />
                </div>            
                <ul className={customer_toggle?"bg-white mt-2 absolute w-[96%] rounded border overflow-x-hidden max-h-64 z-50":"hidden bg-white mt-2 absolute w-[96%] rounded border overflow-x-hidden max-h-64 z-50"}>
                  <div className="flex items-center px-2 sticky top-0 bg-white">
                    <BiSearchAlt size={20} className="text-gray-700" />
                    <input type="text" placeholder="ناوی کڕیار ..." className="w-full p-2 outline-none" value={customer_search} onChange={(val)=>{setcustomer_search(val.target.value)}} />
                  </div>
                  {initState.customer.map((lis)=>(
                    <li key={lis.customer_id} className={`p-2 text-sm hover:bg-slate-600 hover:text-white cursor-default ${lis.customer_name?.startsWith(customer_search)?"block":"hidden"}`} onClick={()=>{
                      setcustomer_id(lis.customer_id);
                      setcustomer_toggle(false);
                      setcustomer_search('');
                      if(lis.customer_id==1){
                        setinvoicetype('cash');
                      }
                    }}>{lis.customer_name}</li>
                  ))}
                </ul>
              </div>

              {/* Service Dropdown */}
              <div className="w-full relative">
                <label className={"block text-base font-medium text-white mb-1 text-right"}>
                  خزمەتگوزاری
                </label>
                <div className="w-full h-12 pr-2 pl-0 border flex justify-between items-center border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white" onClick={()=>{setservice_toggle(!service_toggle)}}>
                  خزمەتگوزاری زیاد بکە
                  <MdKeyboardArrowDown size={18} className={`text-gray-900 transition-transform duration-200 ${service_toggle ? 'rotate-180' : ''}`} />
                </div>            
                <ul className={service_toggle?"bg-white mt-2 absolute w-[96%] rounded border overflow-x-hidden max-h-64 z-50":"hidden bg-white mt-2 absolute w-[96%] rounded border overflow-x-hidden max-h-64 z-50"}>
                  <div className="flex items-center px-2 sticky top-0 bg-white">
                    <BiSearchAlt size={20} className="text-gray-700" />
                    <input type="text" placeholder="ناوی خزمەتگوزاری ..." className="w-full p-2 outline-none" value={service_search} onChange={(val)=>{setservice_search(val.target.value)}} />
                  </div>
                  {initState.service.map((lis)=>(
                    <li key={lis.service_id} className={`p-2 text-sm hover:bg-slate-600 hover:text-white cursor-default ${lis.service_name?.startsWith(service_search)?"block":"hidden"}`} 
                      onClick={()=>{
                        var a={
                          item_id: lis.service_id,
                          service_id: lis.service_id,
                          item_name: lis.service_name,
                          item_barcode: 0,
                          item_price: lis.service_price,
                          item_sell_price: lis.service_price,
                          item_qty: 1,
                          item_quantity: 1,
                          item_min_sell_price:lis.service_price,
                          item_type:'service'
                        };
                        if((items.filter((res)=>res.service_id===lis.service_id).length)<=0){
                          setitems([a,...items]);
                        }else{
                          setitems(items.map((res)=>res.service_id==lis.service_id?
                          {
                            item_id: res.service_id,
                            service_id: res.service_id,
                            item_name: res.item_name,
                            item_barcode: res.item_barcode,
                            item_price: res.item_price,
                            item_sell_price: res.item_sell_price,
                            item_qty: Number(res.item_qty)+1,
                            item_quantity: res.item_quantity,
                            item_min_sell_price:res.item_min_sell_price,
                            item_type:res.item_type
                          }:res));
                        }
                        setservice_toggle(false);
                        setservice_search('');
                      }}
                    >{lis.service_name}</li>
                  ))}
                </ul>
              </div>
            {/* </div> */}
            {/* Sell Button */}
          <div className="w-full">
            <button
              className={
                  items.length < 1 
                  ? "h-12 px-6 bg-indigo-300 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full cursor-not-allowed"
                  : "h-12 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
              }
              disabled={items.length < 1}
              onClick={() => {
                if (items.filter((lis) => lis.item_qty > 0).length < 1) {
                  setitems(items.filter((lis) => lis.item_qty > 0));
                  alert("کاڵای پێویست لە وەسڵدا نییە");
                } else {
                  if(stopsell){

                  }else{
                    if (
                      window.confirm(
                        "دڵنیایی فرۆشتن"
                      ) == true
                    ) {
                    setitems(items.filter((lis) => lis.item_qty > 0));
                    setsell_loading(true);
                    createaction(note, initState.token.id, items,invoicetype,customer_id)(recaller)(
                      setrecaller
                    )(initDispatch)(clear)(printit)(setsell_loading);
                    }
                  }
                }
              }}
            >
              {sell_loading?<div className="flex items-center justify-center space-x-2">
                            <svg
                              className="animate-spin h-5 w-5 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                              ></circle>
                              <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                              ></path>
                            </svg>
                        </div>:"فرۆشتن"}
            </button>
          </div>
          </div>
        </div>

        {/* Items Table */}
        {items.length > 0 && (
          <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
              <div className="w-1/2">
                <h2 className="text-base font-semibold text-slate-800">کۆی گشتی</h2>
              </div>
              <div className="w-1/2">
                <h2 className="text-base font-semibold text-slate-800">{numberbeautify(
                    items.reduce(
                      (a, v) =>
                        (a =
                          Number(a) +
                          Number(v.item_sell_price) * Number(v.item_qty)),
                      0
                    )
                  )}</h2>
              </div>
            </div>

            {/* Table */}
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-100">
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    ناوی کاڵا
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    باڕکۆد
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    جۆر
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    نرخ
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    عەدەد
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    کۆی نرخ
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    ڕەشکردنەوە
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-50">
                {items.map((lis, index) => (
                  <tr key={index}>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {lis.item_name}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {lis.item_barcode}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {lis.item_type=='service'?"خزمەتگوزاری":"کاڵا"}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      <input
                        className={
                          "w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        }
                        id="grid-last-name"
                        type="number"
                        value={lis.item_sell_price}
                        onClick={(val)=>{val.target.select()}}
                        onChange={(val) => {
                          setitems(
                            items.map((lis, indexx) =>
                              index == indexx
                                ? {
                                    item_id: lis.item_id,
                                    service_id: lis.service_id,
                                    item_name: lis.item_name,
                                    item_barcode: lis.item_barcode,
                                    item_price: lis.item_price,
                                    item_sell_price: val.target.value,
                                    item_qty: lis.item_qty,
                                    item_quantity: lis.item_quantity,
                                    item_min_sell_price:lis.item_min_sell_price,
                                    item_type:lis.item_type
                                  }
                                : lis
                            )
                          );
                          // setstopsell(false);
                        }}
                      />
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      <input
                        className={
                          "w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        }
                        id="grid-last-name"
                        type="number"
                        value={lis.item_qty}
                        onClick={(val)=>{val.target.select()}}
                        onChange={(val) => {
                          if(lis.item_type!='service'){
                            if (
                              Number(val.target.value) <=
                              Number(lis.item_quantity)
                            ) {
                              setitems(
                                items.map((lis, indexx) =>
                                  index == indexx
                                    ? {
                                        item_id: lis.item_id,
                                        service_id: lis.service_id,
                                        item_name: lis.item_name,
                                        item_barcode: lis.item_barcode,
                                        item_price: lis.item_price,
                                        item_sell_price: lis.item_sell_price,
                                        item_qty: val.target.value,
                                        item_quantity: lis.item_quantity,
                                        item_min_sell_price:lis.item_min_sell_price,
                                        item_type:lis.item_type
                                      }
                                    : lis
                                )
                              );
                            } else {
                              alert("یەکەی پێویست لەم خاڵایە لە مەخزەن نییە");
                            }
                          }else{
                            setitems(
                              items.map((lis, indexx) =>
                                index == indexx
                                  ? {
                                      item_id: lis.item_id,
                                      service_id: lis.service_id,
                                      item_name: lis.item_name,
                                      item_barcode: lis.item_barcode,
                                      item_price: lis.item_price,
                                      item_sell_price: lis.item_sell_price,
                                      item_qty: val.target.value,
                                      item_quantity: lis.item_quantity,
                                      item_min_sell_price:lis.item_min_sell_price,
                                      item_type:lis.item_type
                                    }
                                  : lis
                              )
                            );
                          }
                        }}
                      />
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      <input
                        className={
                          "w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        }
                        id="grid-last-name"
                        type="number"
                        value={Number(lis.item_qty) * Number(lis.item_sell_price)}
                        onClick={(val)=>{val.target.select()}}
                        onChange={(val) => {
                          setitems(
                            items.map((lis, indexx) =>
                              index == indexx
                                ? {
                                    item_id: lis.item_id,
                                    service_id: lis.service_id,
                                    item_name: lis.item_name,
                                    item_barcode: lis.item_barcode,
                                    item_price: lis.item_price,
                                    item_sell_price: (Number(val.target.value)/Number(lis.item_qty)),
                                    item_qty: lis.item_qty,
                                    item_quantity: lis.item_quantity,
                                    item_min_sell_price:lis.item_min_sell_price,
                                    item_type:lis.item_type
                                  }
                                : lis
                            )
                          );
                          // setstopsell(false);
                        }}
                      />
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      <p className="text-gray-900 whitespace-no-wrap">
                        <MdDeleteForever
                          size={28}
                          color="#e74c3c"
                          className="cursor-pointer"
                          onClick={() => {
                            setitems(
                              items.filter(
                                (list) => list.item_id != lis.item_id
                              )
                            );
                          }}
                        />
                      </p>
                    </td>
                  </tr>
                ))}
                
              </tbody>
            </table>
          </div>
        )}

        {/* Sales List Section */}
      <div className="bg-white border border-slate-100 rounded-xl p-6 mt-6 mb-6 shadow-sm">
        <div className="w-full h-20 flex justify-right items-center text-3xl border-b-2 px-5">
          لیستی فرۆشراو
        </div>
        
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 items-end">
          <div className="w-full mt-2">
            <label
              className={
                error
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
              }
              for="grid-from"
            >
              بەروار{" "}
            </label>
            <input
              className={
                error
                  ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                  : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }
              id="grid-from"
              type="date"
              value={from}
              onChange={(val) => setfrom(val.target.value)}
              onFocus={() => seterror(false)}
            />
          </div>
          <div className="w-full">
            <button
              className={
                "h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
              }
              onClick={() => {
                if (!from || from == "") {
                  seterror(true);
                  return false;
                }
                getinvoiceaction(from)(recaller)(setrecaller)(initDispatch)(
                  clear
                );
              }}
            >
              گەڕان
            </button>
          </div>
        </div>
        </div>
        {initState.today_invoice.length > 0 ? (
          <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
        
            {/* Section Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
              <h2 className="text-base font-semibold text-slate-800">لیستی خەرجی</h2>
            </div>

            {/* Table */}
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-100">
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    ژمارەی وەسڵ
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    بەرواری وەسڵ
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    کۆی کاڵای سەر وەسڵ
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    کۆی نرخی وەسڵ
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    کۆی نرخی فرۆشراو
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    تێبینی
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    جۆری پسوڵە
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    کڕیار
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-50">
                {initState.today_invoice.map((lis, index) => (
                  <tr
                    key={index}
                    className="hover:bg-slate-50 transition-colors duration-100 cursor-pointer"
                    onClick={() => {
                      setinvoice_detail(lis);
                      setshow(true);
                    }}
                  >
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {lis.sell_invoice_id}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {moment(lis.sell_invoice_date).format('YYYY-MM-DD hh:mm A')}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {numberbeautify(
                          money_rounding(
                            lis.items.reduce(
                              (a, v) => (a = Number(a) + Number(v.item_qty)),
                              0
                            )
                          )
                        )}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                          {numberbeautify(
                            iqd_rounding(
                              money_rounding(
                            Number(lis.items.reduce(
                            (a, v) => (a = Number(a) + (Number(v.item_qty)*Number(v.item_price))),
                            0
                          )))))}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                          {numberbeautify(
                            iqd_rounding(
                              money_rounding(
                            Number(lis.items.reduce(
                            (a, v) => (a = Number(a) + (Number(v.item_qty)*Number(v.item_sell_price))),
                            0
                          )))))}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {lis.sell_invoice_note}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {lis.sell_invoice_type=="loan"?"قەرز":"کاش"}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                        {lis.customer_name}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {initState.token.role=='admin'&&
              <table className="min-w-full leading-normal">
                <tbody>
                  <tr>
                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">کۆی فرۆشراو</th>
                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                      {numberbeautify(
                        iqd_rounding(
                          money_rounding(
                        initState?.today_invoice?.reduce(
                              (a, v) => (a = Number(a) + (v.items.reduce(
                                (b, z) => (b = Number(b) + (Number(z.item_qty)*Number(z.item_sell_price))),
                                0
                              ))),
                              0
                            ))))}
                    </td>
                  </tr>
                </tbody>
            </table>}
          </div>
        ) : null}

      </div>
      </div>
    </div>
  );
};

export default Sell;
